import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { GraduationCap, LogIn } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Giriş başarılı");
      navigate("/admin");
    } else {
      toast.error(res.error || "Giriş başarısız");
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#f7f9fa] px-6">
      <div className="w-full max-w-sm">
        <a href="/" className="flex items-center justify-center gap-2 mb-8">
          <span className="grid place-items-center w-10 h-10 rounded-xl bg-[#1B19A8] text-white">
            <GraduationCap size={22} />
          </span>
          <span className="font-display text-2xl font-bold text-[#1a1a1a]">Study in <span className="text-[#1B19A8]">KZ</span></span>
        </a>
        <form onSubmit={submit} data-testid="admin-login-form" className="rounded-3xl bg-white border border-black/5 p-8 shadow-[0_20px_50px_rgba(0,0,0,0.08)] space-y-4">
          <h1 className="font-display text-2xl font-bold text-[#1a1a1a] text-center mb-2">Yönetici Girişi</h1>
          <div>
            <Label htmlFor="email" className="mb-1.5 block">E-posta</Label>
            <Input id="email" type="email" data-testid="login-email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@studyinkz.org" required />
          </div>
          <div>
            <Label htmlFor="password" className="mb-1.5 block">Şifre</Label>
            <Input id="password" type="password" data-testid="login-password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" required />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-[#1B19A8] px-6 py-3.5 font-semibold text-white hover:bg-[#141178] active:scale-[0.98] transition-[background-color,transform] disabled:opacity-60"
          >
            {loading ? "Giriş yapılıyor..." : <>Giriş Yap <LogIn size={18} /></>}
          </button>
        </form>
      </div>
    </div>
  );
}
